// Tijdzone-vaste display-formatters voor datum/tijd (Europe/Amsterdam).
//
// WAAROM een gedeelde helper: in 'use client'-componenten draait dezelfde
// render-code op de server (SSR) én in de browser (hydration). Een
// `toLocaleString` ZONDER expliciete `timeZone` gebruikt de host-tijdzone:
// UTC op de server (Azure Container App, process.tz=UTC) maar Europe/Amsterdam
// in de browser. De tijd-component verschilt dan met de UTC-offset → React
// hydration-mismatch (#425 "Text content does not match" → #422). Door de
// tijdzone hard op 'Europe/Amsterdam' te pinnen is de output identiek op server
// en client (en meteen correct voor de NL-gebruiker).
//
// Conform CLAUDE.md §Tijdzone: `Intl.DateTimeFormat('nl-NL', { timeZone:
// 'Europe/Amsterdam', … })`. Geen datum-library.

const PLACEHOLDER = '—'

// Formatters één keer op module-niveau opgebouwd (de tijdzone is expliciet, dus
// server en client construeren een identieke formatter → identieke output).
const DATUM_KORT_FMT = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
})

const DATUM_TIJD_FMT = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

function toDate(iso: string | null | undefined): Date | null {
  if (!iso) return null
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}

/**
 * Korte datum-weergave in Europe/Amsterdam, bv. `24 jun. 2026`.
 * `null`/leeg/ongeldig → de em-dash-placeholder (`—`).
 */
export function formatNlDatumKort(iso: string | null | undefined): string {
  const d = toDate(iso)
  return d ? DATUM_KORT_FMT.format(d) : PLACEHOLDER
}

/**
 * Datum + tijd in Europe/Amsterdam, bv. `24 jun. 2026 10:30`.
 * `null`/leeg/ongeldig → de em-dash-placeholder (`—`).
 */
export function formatNlDatumTijd(iso: string | null | undefined): string {
  const d = toDate(iso)
  return d ? DATUM_TIJD_FMT.format(d) : PLACEHOLDER
}
